<template>
  <div>
    <!-- modals -->
    <Filters @close="posFilters" />
    <Email :client_id="clientId" @success="fetchSales(filters)"/>

    <PageHeader :title="title" :items="items" />

    <ModalViewPdf :fetch-pdf="fetchPdf" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <!-- Items per page -->
          <b-row class="row pb-2">
            <!-- Filter -->
            <b-col cols="12" sm="12" md="5" >
              <div class="d-flex align-items-center">
                <!-- Filter Button-->
                <div class="ml-2 mr-2">
                  <b-button v-b-modal.modal-filter-sales variant="success">
                    Filtros
                  </b-button>
                </div>
                <!-- Filter Per Page -->
                <div v-if="getIsInternational" class="d-flex align-items-center gap-1 pr-3">
                  <span>Moeda&nbsp;</span>
                  <div>
                    <b-form-select
                      v-model="selectedCurrency"
                      size="sm"
                      :options="optionsCurrency"
                      class="ml-1"
                    />
                  </div>
                </div>
                <span>Mostrar&nbsp;</span>
                <div>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </div>
                <span>&nbsp;por página</span>
              </div>
            </b-col>
            <!-- Search -->
            <b-col cols="12" sm="12" md="7" class="d-flex justify-content-end align-items-center">
              <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="transaction_id"
                    type="search"
                    placeholder="ID Transação..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="sale_id"
                    type="search"
                    placeholder="ID Greenn..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="product_name"
                    type="search"
                    placeholder="Nome do produto..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="client_email"
                    type="search"
                    placeholder="E-mail do cliente..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="client_document"
                    type="search"
                    placeholder="CPF do cliente..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="client_cellphone"
                    type="search"
                    placeholder="Contato do cliente..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="d-inline-flex align-self-start ml-2">
                <b-button variant="success" size="sm" @click="onSearch">
                  <i class="fas fa-search"></i>
                </b-button>
              </div>
            </b-col>
            <!-- Currency Filter -->
            <!-- <div class="col-sm-12 col-md-2 mb-2 d-flex justify-content-end">
              <SelectCurrency
                :currency="currency"
                :base-currencies="true"
                @update-coin="updateCoin"
              />
            </div> -->
          </b-row>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div v-if="movements.length > 0 && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  :items="movements"
                  :fields="fields"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >
                  <!-- Id -->
                  <template v-slot:cell(transaction_id)="data">
                    <div class="d-flex align-items-center">
                      <a :title="data.value">
                        {{
                          data.value.length >= 10
                            ? data.value.substr(0, 10) + '...'
                            : data.value
                        }}
                      </a>
                      <img
                        :src="require('@assets/img/icons/copy.svg')"
                        alt="Copiar"
                        class="copy-icon ml-2"
                        @click="copyToClipboard(data.value)"
                      />
                    </div>
                  </template>
                  <!-- Client -->
                  <template v-slot:cell(_client)="data">
                    {{ data.item.client.name }}<br />
                    {{ data.item.client.email }}
                    <br />
                    {{ data.item.client.cellphone }}
                  </template>
                  <!-- Seller -->
                  <template v-slot:cell(_seller)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                        :style="setColor(data.item.seller.classification)"
                      ></div>
                    </div>
                    {{ data.item.seller.id }} - {{ data.item.seller.name }}
                    <br />
                    {{ data.item.seller.email }}
                    <br />
                    {{ data.item.seller.cellphone }}
                    <NewProgressBar v-if="data.item.seller.score && data.item.seller.score.total_score" :type="'SellerScore'" :valor="data.item.seller.score.total_score"/>
                  </template>
                  <!-- Date -->
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>
                  <!-- Product -->
                  <template v-slot:cell(_product)="data">
                    #{{ data.item && data.item.product_id ? data.item.product_id : '' }}
                    <br />

                    {{ data.item && data.item.product? data.item.product.name : '' }}
                    <br />

                    {{ data.item && data.item.product ? getTypeProduct(data.item.product.format) : '' }}
                  </template>
                  <!-- Score -->
                  <template v-slot:cell(score)="data">
                    <NewProgressBar v-if="data.item.analyze" :type="'RiskScorre'" :valor="data.item.risk_score"/>
                  </template>
                  <!-- Status -->
                  <template v-slot:cell(status)="data">
                    <b-badge v-if="data.value === 'unpaid'" variant="secondary">
                      Não pago
                    </b-badge>
                    <b-badge v-if="data.value === 'refund_pending'"
                      variant="warning"
                    >
                      Reembolso pendente
                    </b-badge>
                    <b-badge v-if="data.value === 'refunded'" variant="danger">
                      Reembolsado
                    </b-badge>
                    <b-badge v-if="data.value === 'paid'" variant="success">
                      Pago
                    </b-badge>
                    <b-badge v-if="data.value === 'processing' || data.value === 'waiting_payment'"
                      variant="secondary"
                    >
                      Processando
                    </b-badge>
                    <b-badge v-if="data.value === 'refused' || data.value === 'reject'"
                      variant="danger"
                    >
                      Recusada
                    </b-badge>
                    <b-badge v-if="data.value === 'chargedback'" variant="dark">
                      Charged Back
                    </b-badge>
                    <b-badge v-if="data.value === 'trialing'" variant="info">
                      Avaliação
                    </b-badge>
                  </template>
                  <!-- Greenn Value -->
                  <template v-slot:cell(total)="data">
                    {{ data.item.currency_symbol }} {{ formatMoney(data.item.status === 'paid' ? data.value : 0) }}
                  </template>
                  <!-- Distributed  Value -->
                  <template v-slot:cell(balance)="data">
                    {{ data.item.currency_symbol }} {{ formatMoney(data.value ? data.value : 0) }}
                  </template>
                  <!-- Method -->
                  <template v-slot:cell(method)="data">
                    <PaymentMethodIcon :method="data.value" />
                  </template>
                  <!-- Actions -->
                  <template v-slot:cell(_actions)="data">
                    <div v-if="!attendance && !success">
                      <b-button
                        v-if="$canAction('sales_login_button', 'editor')"
                        v-b-tooltip.hover title="Ir para login"
                        variant="info"
                        class="mb-1 w-100"
                        @click="login(data.item.seller_id)"
                      >
                        <i class="fas fa-sign-in-alt"></i>
                      </b-button>
                      <b-button
                        v-if="$canAction('sales_email_edit_button', 'editor')"
                        v-b-tooltip.hover title="Alterar e-mail"
                        variant="warning"
                        class="mb-1 w-100"
                        @click="openEmail(data.item.client_id)"
                      >
                        <i class="fas fa-edit"></i>
                      </b-button>
                      <b-button
                        v-if="
                          canShowCancelSubscriptionButton(data.item) &&
                          canCancelSubscriptionAsEditor()"
                        v-b-tooltip.hover
                        title="Cancelar Assinatura"
                        variant="danger"
                        class="mb-1 w-100"
                        @click="deny(data.item.client_contract.id)"
                      >
                        <i class="fas fa-times"></i>
                      </b-button>
                      <span
                        v-else-if="canShowCancelSubscriptionButton(data.item)"
                        v-b-tooltip.hover.focus.bottom="{ title: 'Sem permissão para cancelar', customClass: 'cancel-subscription-tooltip' }"
                        class="d-inline-block w-100 cancel-subscription-btn-disabled-wrapper"
                        tabindex="0"
                        role="button"
                        aria-disabled="true"
                        aria-label="Cancelar assinatura desabilitado: sem permissão para cancelar"
                      >
                        <b-button
                          variant="danger"
                          class="mb-1 w-100 cancel-subscription-btn-disabled cancel-subscription-btn-disabled-inner"
                          disabled
                        >
                          <i class="fas fa-times"></i>
                        </b-button>
                      </span>
                      <b-button
                        v-if="
                          $canAction('sales_refund_receipt_button', 'editor') &&
                          data.item.status === 'refunded'"
                        v-b-tooltip.hover title="Comprovante de estorno"
                        variant="primary"
                        class="btn mb-1 w-100 btn-info  button-receipt"
                        @click="openReceipt(data.item.id)"
                      >
                       <img class="pointer" src="@assets/images/receipt.svg"/>
                      </b-button>
                    </div>
                  </template>

                  <!-- Show More Details -->
                  <template v-slot:row-details="row">
                    <div class="text-right">
                      <div
                        v-for="account in row.item.accounts"
                        :key="account.id"
                      >
                        <b>{{ account.user.name }}</b>
                        : {{ currencySymbol }} {{ formatMoney(account.balance) }}
                      </div>
                      <br />
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <!-- Loading -->
          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <!-- Pagination -->
          <div v-if="movements.length > 0" class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @change="changeCurrentPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

          <!-- Feedback Menssage -->
          <div v-if="movements.length === 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-primary" role="alert">
              Sem extrato financeiro.
            </div>
          </div>
          <FilterSales
            :currencyActual="this.filters.coinId"
            @close="posFilters"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import SalesService from '@services/resources/SalesService'
import CancelSubscriptionService from '@services/resources/CancelSubscriptionService'
import Money from '@src/mixins/money'
import Filters from '@components/sales/filters'
import Email from '@components/sales/email'
// import SelectCurrency from '@components/SelectCurrency'
import _ from 'lodash'
import validAcessRoute from '@src/utils/validAcessRoute'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import FilterSales from '@/src/components/filters/FilterSales.vue'
import ModalViewPdf from '@/src/components/@shared/ModalViewPdf.vue'
import { mapGetters } from 'vuex';

var service = SalesService.build()
var serviceCancelSubscription = CancelSubscriptionService.build()

/**
 * Get current month date range (first and last day)
 * @return {{ first: string, last: string }} Datas locais no formato YYYY-MM-DD
 */
function getCurrentMonthRange() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const first = new Date(year, month, 1);
  const last = new Date(year, month + 1, 0);
  const pad = n => String(n).padStart(2, '0');
  const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return {
    first: format(first),
    last: format(last)
  };
}

export default {
  page: {
    title: 'Vendas',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, Filters, Email, NewProgressBar, FilterSales, ModalViewPdf },
  mixins: [Money],
  props: {
    modalDenyApproved: {
      required: true,
      type: Boolean,
      default: false
    },
  },
  data() {
    const monthRange = getCurrentMonthRange();
    return {
      attendance: validAcessRoute(
        ['attendance'],
        this.$store.getters.getProfile
      ),
      clientId: -1,
      currency: {
        id: 1,
        name: "Real Brasileiro",
        currency: "BRL",
        currency_symbol: "R$",
        created_at: "2022-06-27T20:11:50.000000Z",
        updated_at: "2022-06-27T20:11:50.000000Z",
        is_base_currency: 1,
      },
      currentPage: 1,
      currencySymbol: "R$",
      fields: [
        { key: 'transaction_id', label: 'ID Transação', sortable: true },
        { key: 'id', label: 'ID Greenn', sortable: true },
        { key: '_client', label: 'Cliente', sortable: false },
        { key: '_seller', label: 'Vendedor', sortable: false },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: '_product', label: 'Produto', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'score', label: 'Risco', sortable: false },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'balance', label: 'Valor distribuído', sortable: true },
        { key: 'method', label: 'Método', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
        { key: 'show_details', label: 'Distribuição' },
      ],
      transaction_id: null,
      sale_id: null,
      product_name: null,
      client_email: null,
      client_document: null,
      client_cellphone: null,
      filterOn: [],
      filters: {
        date_start: monthRange.first,
        date_end: monthRange.last,
        status: null,
        method: null,
        user_id: null,
      },
      items: [
        { text: 'Início', href: '/' },
        { text: 'Vendas', active: true },
      ],
      selectedCurrency: 0,
      optionsCurrency: [
        { value: 0, text: 'Todos' },
        { value: 1, text: 'BRL' },
        { value: 2, text: 'USD' },
        { value: 3, text: 'EUR'},
      ],
      loading: true,
      movements: [],
      perPage: 20,
      pageOptions: [20, 50, 100],
      solicitation: {},
      sortBy: 'name',
      sortDesc: false,
      success: validAcessRoute(['success'], this.$store.getters.getProfile),
      title: 'Vendas',
      totalCurrency: 0,
      totalRows: 1,

      saleSelected: 0
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    ...mapGetters({
      getIsInternational: 'getIsInternational',
    }),
  },
  watch: {
    perPage() {
      this.fetchSales()
    },
    filter() {
      this.debounce()
    },
    modalDenyApproved() {
      if(this.modalDenyApproved) this.deny();
    },
    selectedCurrency() {
      this.currentPage = 1
      this.fetchSales(this.filters)
    }
  },
  created() {
    this.fetchSales(this.filters);
  },
  methods: {
    onSearch() {
      this.currentPage = 1
      this.debounce()
    },
    canCancelSubscriptionAsEditor() {
      return this.$canAction('sales_cancel_subscription_button', 'editor')
    },
    canShowCancelSubscriptionButton(item) {
      return this.$canAction('sales_cancel_subscription_button', 'reader') &&
        item.type === 'SUBSCRIPTION' &&
        !!(item.client_contract && item.client_contract.status !== 'canceled')
    },
    changeCurrentPage(currentPage) {
      this.fetchSales({}, 'BRL', currentPage)
    },
    /**
     * Get the type of product and translate it for the user to view in the table
     * @param type - String - product type
     * @return String - product type translated
     * @author Sandro Souza
     */
    getTypeProduct(type) {
      let t = ''
      if (type) {
        switch (type.toUpperCase()) {
          case 'INFOPRODUCT': t = 'InfoProduto'
          break
          case 'SERVICE': t = 'Serviço'
          break
          case 'PHYSICALPRODUCT': t = 'Produto Físico'
          break
          case 'EVENT': t = 'Evento'
          break
          case 'OTHERS': t = 'Outros'
          break
          default: t = type
          break
        }
        return t
      } else return type
    },
    /**
     * Filter table data
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    debounce: _.debounce(function () {
      this.fetchSales(this.filters)
    }, 500),
    /**
     * Fires when user presses OK in filter modal. Called by Filters component event. Set local variable "this.filtros" with the filters selected by the user and make the request looking for sales with these filters applied
     * @param filters - Object
     * @return no return
     * @author Sandro Souza
     */
    posFilters(filters) {
      this.filters = filters
      this.fetchSales(this.filters)
    },
    /**
     * Open SweetAlert2 to cancel signature
     * @param chc_id - chc_id
     * @return no return
     * @author Sandro Souza
     */
    deny(chc_id) {
      Vue.swal({
        title: 'Cancelar Assinatura',
        text: 'Deseja realmente cancelar a assinatura?',
        type: 'warning',
        inputAttributes: { autocapitalize: 'off' },
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      }).then(() => {
        if(chc_id) {
          serviceCancelSubscription.destroy({ id: chc_id })
            .then(() => {
              Vue.swal('Cancelada!', 'A assinatura foi cancelada com sucesso.', 'success')
              this.fetchSales()
            })
            .catch((err) => {
              if(err && err.id) {
                Vue.swal('Erro!', err.id[0], 'error')
              } else {
                Vue.swal('Erro!', 'Ocorreu um erro ao cancelar assinatura.', 'error')
              }
            })
            .finally(() => { this.loading = false })
        } else {
          Vue.swal('Erro!', 'Id de client_has_contract não informado.', 'error')
        }
      })
    },
    /**
     * Makes a request looking for a list of sales and totals filtered by currency, and other filters may be applied
     * @param filters - Object
     * @param currency - String
     * @return no return
     * @author Sandro Souza
     */
    fetchSales(filters = {}, currency = 'BRL', currentPage = null) {
      this.loading = true
      this.movements = []

      if(!currency) currency = this.currency.currency
      if(currentPage) this.currentPage = currentPage
      var data = {
        per_page: this.perPage,
        page: currentPage || this.currentPage,
        currency: this.isHeaven ? 'USD' : 'BRL',
        coin_id: this.selectedCurrency
        // currency
      }

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.transaction_id) data.transaction_id = this.transaction_id
      if (this.sale_id) data.id = this.sale_id
      if (this.product_name) data.product_name = this.product_name
      if (this.client_email) data.client_email = this.client_email
      if (this.client_document) data.client_document = this.client_document
      if (this.client_cellphone) data.client_cellphone = this.client_cellphone

      service
        .search(data)
        .then((resp) => {
          this.movements = resp.data.data
          this.totalRows = resp.data.total
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    /**
     * Set color in style dot before seller name on table depending on seller classification
     * @param color - String
     * @return String - css style background color
     * @author Sandro Souza
     */
    setColor(color) {
      if (color) {
        switch (color) {
          case 'green': return 'background: #00E4A0'
          case 'yellow': return 'background: #fff700'
          case 'red': return 'background: #FF0A44'
          case 'black': return 'background: #000000'
          default: return 'background:#c7c7c7;'
        }
      }
    },
    /**
     * Fires when user selects a currency. Makes a request filtering the table data by the selected currency
     * @param currency - Object
     * @return no return
     * @author Sandro Souza
     */
    updateCoin(currency) {
      this.currency = currency;
      this.currencySymbol = currency.currency_symbol;
      this.fetchSales({}, currency.currency);
    },
    // Actions Sales
    /**
     * Redirects user to another tab in browser to login to adm.
     * @param id - Number
     * @return no return
     * @author Sandro Souza
     */
    login(id) {
      let url = (this.isHeaven ? process.env.VUE_APP_HEAVEN_ADM_PAGE : process.env.VUE_APP_ADM_PAGE) + '/admin-login/' + btoa(id)
      window.open(url)
    },
    /**
     * Open e-mail modal and sends client id to component
     * @param clientId - Number
     * @return no return
     * @author Sandro Souza
     */
    openEmail(clientId) {
      this.clientId = clientId
      this.$bvModal.show('modal-email')
    },

    async fetchPdf() {
      return service.getRefundReceipt(this.saleSelected)
    },

    openReceipt(id) {
      this.saleSelected = id;
      this.$bvModal.show('modal-view-pdf')
    },
    copyToClipboard(value) {
      navigator.clipboard.writeText(value)
        .then(() => {
          this.$bvToast.toast('ID da Transação copiado!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 2000
          })
        })
        .catch(() => {
          this.$bvToast.toast('Erro ao copiar', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
        })
    }
  }
}
</script>
<style>

.button-receipt {
  background-color: #FFE3D4 !important;
  border: none !important;
  height: 36px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.button-receipt i {
  color: #FF4820 !important;
  font-size: 8px !important;
}

.button-receipt:hover i {
  color: #FFE3D4 !important;
}

.cancel-subscription-btn-disabled:disabled {
  opacity: 0.2 !important;
}

.cancel-subscription-btn-disabled-inner:disabled {
  pointer-events: none;
}

.cancel-subscription-tooltip .tooltip-inner {
  max-width: none;
  white-space: nowrap;
}

.copy-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>
